'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { SessionProvider } from 'next-auth/react'; // Add for Auth
import { ToastContainer } from 'react-toastify'; // Add for Notifications
import { ReactNode, useState } from 'react';

// Import CSS for Toastify here if not already in globals.css
import 'react-toastify/dist/ReactToastify.css';

export default function Providers({ children }: { children: ReactNode }) {
  const [queryClient] = useState(() => new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
        // Retries can sometimes cause "awkward" loading loops if the DB is down
        retry: 1, 
      },
    },
  }));

  return (
    <SessionProvider>
      <QueryClientProvider client={queryClient}>
        {children}
        
        {/* --- UI OVERLAYS --- */}
        <ToastContainer
          position="bottom-right"
          theme="dark" // Matches your "Architect" aesthetic
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnHover
          draggable
        />
        
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </SessionProvider>
  );
}